import { useLayoutEffect, useRef, useState } from "react";
import { LETTER_CSS, buildLetterInnerHtml } from "../lib/letterPdf";

const A4_W_MM = 210;
const DEFAULT_M = { top: 25, right: 20, bottom: 25, left: 25 };

// Anteprima WYSIWYG: renderizza esattamente lo stesso DOM (HTML + CSS) che html2canvas
// trasforma nel PDF, su un foglio A4 reale (210mm) con i margini della pratica, scalato
// per adattarsi al contenitore. Ciò che si vede qui corrisponde al PDF scaricato.
export function LetterA4Preview({ contentHtml, withHead, inte, margins, footer, center = false }) {
  const wrapRef = useRef(null);
  const sheetRef = useRef(null);
  const [scale, setScale] = useState(1);
  const [height, setHeight] = useState(0);
  const [sheetW, setSheetW] = useState(0);
  const m = margins && typeof margins.top === "number" ? margins : DEFAULT_M;
  const inner = buildLetterInnerHtml({ contentHtml, withHead, inte });

  useLayoutEffect(() => {
    const compute = () => {
      const wrap = wrapRef.current, sheet = sheetRef.current;
      if (!wrap || !sheet) return;
      const natural = sheet.offsetWidth; // px equivalenti a 210mm
      const s = natural ? Math.min(1, wrap.clientWidth / natural) : 1;
      setScale(s);
      setHeight(sheet.offsetHeight * s);
      setSheetW(natural * s);
    };
    compute();
    const ro = new ResizeObserver(compute);
    if (wrapRef.current) ro.observe(wrapRef.current);
    if (sheetRef.current) ro.observe(sheetRef.current);
    const t = setTimeout(compute, 60);
    return () => { ro.disconnect(); clearTimeout(t); };
  }, [contentHtml, withHead, inte, m.top, m.right, m.bottom, m.left]);

  return (
    <div ref={wrapRef} style={{ width: "100%", overflow: "hidden", ...(center ? { display: "flex", justifyContent: "center" } : {}) }} data-testid="letter-a4-preview">
      <div style={{ height, ...(center && sheetW ? { width: sheetW, overflow: "hidden" } : {}) }}>
        <div
          ref={sheetRef}
          className="pgp-pdfroot"
          style={{
            width: `${A4_W_MM}mm`,
            minHeight: "297mm",
            padding: `${m.top}mm ${m.right}mm ${m.bottom}mm ${m.left}mm`,
            background: "#fff",
            position: "relative",
            transformOrigin: "top left",
            transform: `scale(${scale})`,
            boxShadow: "0 2px 14px rgba(0,0,0,0.28)",
          }}
        >
          <style>{LETTER_CSS}</style>
          <div dangerouslySetInnerHTML={{ __html: inner }} />
          {footer && (
            <div style={{ position: "absolute", left: `${m.left}mm`, right: `${m.right}mm`, bottom: "4mm", pointerEvents: "none" }} data-testid="letter-footer-preview">
              <div style={{ borderTop: "0.2mm solid #969696", marginBottom: "1.2mm" }} />
              <div style={{ textAlign: "right", fontSize: "7pt", lineHeight: 1.3, color: "#787878", fontFamily: "'Inter',Arial,Helvetica,sans-serif" }}>
                <div>Elaborato con PatroGestPro</div>
                <div>1/1</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
